import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import EditAgencyInfoModal from './EditAgencyInfoModal';
import usePost from '../../../Hooks/usePost';
import propTypes from 'prop-types';
import { StyledButton } from '../../../Components/Generics.styled';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import { useAgency } from '../../../Contexts/AgencyContext';
const AgencyInfoContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const AgencyInfoApplet = styled.div`
    margin-top: 40px;
    border: 1px solid black;
    height: 100%;
    width: 100%;
    max-width: 800px;
    text-align: center;
    padding: 12px;
    background-color: #fafbf7;
    border-radius: 12px;
    opacity: 1;
`;

const Label = styled.div`
    padding: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000000;
    text-align: left;
`;

const StyledValue = styled.span`
    letter-spacing: 0px;
    color: #000000;
    padding-left: 8px;
    font-weight: bold;
`;

const StyledHR = styled.hr`
    margin-top: 0px;
    margin-bottom: 0px;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    text-align: center;
`;

const AgencyInformation = ({ agency }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { post: postUpdateAgency } = usePost('/updateAgency');
    const { setShouldFetchAdvertiserData, setCurrentAdvertiser, currentAdvertiser } =
        useAdvertisers();
    const { setShouldFetchAgencyData } = useAgency();
    const [postData, setPostData] = useState({
        success: null,
        error: null,
        isLoading: false,
        message: [''],
    });

    const role = {
        isAgencyManager: currentAdvertiser?.isAgencyManager,
        isAgencyPrimary: currentAdvertiser?.isAgencyPrimary,
    };

    const [agencyInfo, setAgencyInfo] = useState({
        status: '',
        companyName: '',
        companyWebsite: '',
        firstName: '',
        lastName: '',
        title: '',
        primaryPhone: '',
        mobilePhone: '',
        streetAddress: '',
        secondaryAddress: '',
        city: '',
        province: '',
        country: '',
        zipCode: '',
        planTypeName: '',
        planTypeId: '',
    });
    const noAccountData = Object.keys(agencyInfo).length === 0;
    const {
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        city,
        province,
        country,
        zipCode,
        planTypeName,
        agencyId,
        planTypeId,
        stripeCustomerId,
        isBilledAnnually,
    } = { ...agencyInfo };

    const resetFields = () => {
        setAgencyInfo({
            ...agency,
        });
    };
    useEffect(() => {
        resetFields();
    }, [agency]);

    const saveAgencyData = async () => {
        setPostData({ ...postData, isLoading: true });
        try {
            const body = {
                agencyId,
                companyName,
                companyWebsite,
                firstName,
                lastName,
                title,
                primaryPhone,
                mobilePhone,
                streetAddress,
                country,
                city,
                province,
                zipCode,
                planTypeId,
                planTypeName,
                stripeCustomerId,
                isBilledAnnually,
            };
            await postUpdateAgency(body, 'POST');
            setCurrentAdvertiser({ ...body, isAgencyPrimary: true });
            setShouldFetchAgencyData(true);
            setShouldFetchAdvertiserData(true);

            setPostData({ ...postData, isLoading: false, success: true });
        } catch (error) {
            setPostData({ ...postData, isLoading: false, success: false, error: true });
        }
    };

    const { error } = { ...postData };

    return (
        <AgencyInfoContainer>
            <Title>Agency Information</Title>
            <AgencyInfoApplet>
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Company Name:
                        <StyledValue>{companyName}</StyledValue>{' '}
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Company Website:
                        <StyledValue>{companyWebsite}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        First Name:
                        <StyledValue>{firstName}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Last Name:
                        <StyledValue>{lastName}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Your Title:
                        <StyledValue>{title}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Primary Phone:
                        <StyledValue>{primaryPhone}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Mobile Phone:
                        <StyledValue>{mobilePhone}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Street:
                        <StyledValue>{streetAddress}</StyledValue>
                    </Label>
                )}

                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Country:
                        <StyledValue>{country}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        State:
                        <StyledValue>{province}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        City:
                        <StyledValue>{city}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Zip:
                        <StyledValue>{zipCode}</StyledValue>
                    </Label>
                )}
                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Plan Type:
                        <StyledValue>{planTypeName}</StyledValue>
                    </Label>
                )}

                <StyledHR />
                {noAccountData || error ? (
                    <Skeleton animation="wave" />
                ) : (
                    <Label>
                        Account Type:
                        <StyledValue>Agency</StyledValue>
                    </Label>
                )}

                <StyledHR />
                <br />
                {role.isAgencyManager ? (
                    <StyledButton onClick={() => setModalIsOpen(true)}>Update</StyledButton>
                ) : null}
                <EditAgencyInfoModal
                    agencyInfo={agencyInfo}
                    setAgencyInfo={setAgencyInfo}
                    setModalIsOpen={setModalIsOpen}
                    postData={postData}
                    modalIsOpen={modalIsOpen}
                    resetFields={resetFields}
                    saveAgencyData={saveAgencyData}
                />
            </AgencyInfoApplet>
        </AgencyInfoContainer>
    );
};

AgencyInformation.propTypes = {
    agency: propTypes.shape({}),
};

export default AgencyInformation;
